const CustomSelect = ({ name, value, onChange, options = [] }) => {
  return (
    <select
      className="h-[45px] w-full text-[14px] rounded-[2px] px-[10px] border border-[#D9D9D9] focus:outline-none focus:ring-0 focus:ring-offset-0 focus:border-[#D9D9D9] bg-white"
      name={name}
      id={name}
      value={value}
      onChange={onChange}
    >
      <option value="">Select an option</option>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default CustomSelect;
